import { solid } from '@fortawesome/fontawesome-svg-core/import.macro'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useEffect } from 'react'
import CustomButton from '../../../Components/CustomButton'
import fetchApiError from '../../../Helpers/fetchApiError'
import { useForm } from '../../../Hooks/useForm'
import TrackingService from '../../../Services/Tracking'
import './styles.scss'

const Tracker = ({ setTrackItResult }) => {
  const { form, onChange, reset } = useForm({
    trackingNumber: '',
    loading: false,
    error: null,
  })

  useEffect(() => {
    return reset
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const handleSubmit = async (e) => {
    e.preventDefault()
    onChange('loading', true)
    onChange('error', null)

    try {
      const res = await TrackingService.get_by_tracking_number(form.trackingNumber)
      setTrackItResult(res.data.data)
    } catch (error) {
      setTrackItResult(null)
      onChange('error', fetchApiError(error))
    }

    onChange('loading', false)
  }

  return (
    <div className="tracker">
      <div className="tracker__card">
        <div className="tracker__icon-wrap">
          <img src={`${process.env.PUBLIC_URL}/favicon.png`} alt="Sterling Logistics" />
        </div>

        <h2>Track Your Shipment</h2>
        <p>Enter your airwaybill or tracking number below to get a live status update on your shipment.</p>

        <form onSubmit={handleSubmit}>
          <div className="tracker__field">
            <FontAwesomeIcon icon={solid('magnifying-glass')} className="tracker__field__icon" />
            <input
              type="text"
              placeholder="e.g. SL-12345678"
              value={form.trackingNumber}
              onChange={(e) => onChange('trackingNumber', e.target.value)}
              required
            />
          </div>

          {form.error && (
            <div className="tracker__error">
              <FontAwesomeIcon icon={solid('triangle-exclamation')} />
              {form.error}
            </div>
          )}

          <CustomButton
            loading={form.loading}
            label="Track Shipment"
            type="submit"
            otherClassName="tracker__btn"
          />
        </form>
      </div>
    </div>
  )
}

export default Tracker
